namespace TotalContest {
    import Component = TotalCore.Common.Component;
    import ILocationService = angular.ILocationService;
    import Processable = TotalCore.Common.Processable;
    import RepositoryService = TotalContest.RepositoryService;

    @Component('components.totalcontest', {
        templateUrl: 'log-browser-component-template',
        bindings: {}
    })
    class LogBrowserComponent extends Processable {
        public columns = {
            'status': true,
            'action': true,
            'date': true,
            'ip': true,
            'user_id': false,
            'user_login': false,
            'user_name': true,
            'user_email': false,
            'browser': true,
        };
        public currentPage = 1;
        public entries = [];
        public filters: any = {};
        public labels = {
            'user': 'User',
            'sentVia': 'Sent via',
            'env': 'Environment',
        };
        public lastPage = true;
        public exporting = false;
        public exports = [];

        constructor(private RepositoryService: RepositoryService, private $location: ILocationService) {
            super();
            let urlParams = $location.search();

            this.currentPage = Math.abs(Number(urlParams['current']) || 1);
            this.filters.from = urlParams['from'] || null;
            this.filters.to = urlParams['to'] || null;
        }

        $onInit() {
            this.loadPage(this.currentPage);
        }

        canExport() {
            return this.entries.length > 0;
        }

        exportAs(format) {
            //this.RepositoryService.getDownload(format, this.filters);
            const exportModel = {
                status: 'requested',
                format: format
            };

            this.exports.push(exportModel);

            this.RepositoryService.getExport(format, this.filters, Object.keys(this.columns).filter(key => this.columns[key]))
                .then((response) => {
                    this.exports[this.exports.indexOf(exportModel)] = response;
                    this.refreshExportStatus(response);

                    setTimeout(
                        () => {
                            document.querySelector('.totalcontest-log-browser-exports')
                                .scrollIntoView({behavior: "smooth"});
                        },
                        10
                    );
                })
                .catch((response) => {
                    this.exports.splice(this.exports.indexOf(exportModel), 1);
                })
                .finally(() => {

                });
        }

        refreshExportStatus(exportModel) {
            if (!exportModel.timeout) {
                exportModel.timeout = setTimeout(
                    () => {
                        this.RepositoryService
                            .getExportStatus(exportModel.uid)
                            .then((response) => {
                                this.exports[this.exports.indexOf(exportModel)] = exportModel = response;

                                if (exportModel.status !== 'finished') {
                                    this.refreshExportStatus(exportModel);
                                }
                            })
                    },
                    5000
                );
            }
        }

        exportPercentage(exportModel) {
            return (((exportModel.processed || 0) / (exportModel.total || 1)) * 100).toFixed(0);
        }

        hasNextPage() {
            return !this.lastPage;
        }

        hasPreviousPage() {
            return this.currentPage != 1;
        }

        isFirstPage() {
            return this.currentPage === 1;
        }

        isLastPage() {
            return this.lastPage;
        }

        isPage(page) {
            return this.currentPage == page;
        }

        loadPage(page: number) {
            this.startProcessing();
            this.RepositoryService
                .getPage(page, this.filters)
                .then((response) => {
                    this.currentPage = page;
                    this.entries = response['entries'];
                    this.lastPage = response['lastPage'];
                    this.updateUrl();
                })
                .catch((response) => {
                    if (confirm(`Something went wrong in the last operation (${response.status} ${response.statusText || 'Unknown error'}). Retry?`)) {
                        this.loadPage(page);
                    }
                })
                .finally(() => {
                    this.stopProcessing();
                });
        }

        removeItem(item, $event) {
            let confirmation = $event.altKey ? true : confirm('Are you sure? this is an irreversible action! You can bypass this confirmation next time by holding the ALT key.');

            if (confirmation) {
                this.startProcessing();

                this.RepositoryService.remove(item.attributes.id).then((response) => {
                    if (response.success) {
                        $event.target.closest('tr').remove();
                    } else {
                        alert('Unable to remove item');
                    }
                }).finally(() => {
                    this.stopProcessing();
                });
            }
        }

        nextPage() {
            this.loadPage(this.currentPage + 1);
        }

        previousPage() {
            this.loadPage(this.currentPage - 1);
        }

        resetFilters() {
            this.filters.from = null;
            this.filters.to = null;
            this.loadPage(1);
        }

        updateUrl() {
            this.$location.search(angular.extend({}, this.$location.search(), this.filters, {current: this.currentPage}));
        }

        isExporting() {
            return this.exporting;
        }
    }
}
